import { Routes, Route, Link, useLocation } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import ContactUs from './ContactUs';
import './App.css';

function App() {
  const location = useLocation();

  return (
    <div className="app">
      <nav className="app-nav">
        <div className="nav-content">
          <span className="nav-brand">🌿 Plant Care Reminder</span>
          <div className="nav-links">
            <Link
              to="/"
              className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className={`nav-link ${location.pathname === '/terms' ? 'active' : ''}`}
            >
              Terms of Use
            </Link>
            <Link
              to="/contact"
              className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
            >
              Contact Us
            </Link>
          </div>
        </div>
      </nav>
      <Routes>
        <Route path="/" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </div>
  );
}

export default App;
